/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sd_Segment_Process_Entire_VideoInputs */



/**
* | output |
* | --- |
* | "Process the entire video" |
*
* @param {Sd_Segment_Process_Entire_VideoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sd_segment_process_entire_video = /** @type {((inputs?: Sd_Segment_Process_Entire_VideoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sd_Segment_Process_Entire_VideoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Traiter la vidéo entière")
	if (locale === "de") return /** @type {LocalizedString} */ ("Das gesamte Video verarbeiten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elabora l'intero video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обработайте всё видео.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Procesar todo el vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("处理整个视频")
	if (locale === "ja") return /** @type {LocalizedString} */ ("動画全体を処理する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूरे वीडियो को प्रोसेस करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Processar o vídeo inteiro")
	return /** @type {LocalizedString} */ ("Process the entire video")
});